<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Users Device Types</p>

    <small class="mb-2 d-inline-block">Results shown are from current data only, date range applied does not change results</small>

    <section class="call-stats__items" v-if="!loading">
      <p class="text-center title-divider top-divider font-weight-bold">
        Device Type breakdown of verified users
      </p>

      <section class="d-flex full-width">
        <p class="text-right brand-color font-weight-bold">
          Total Users: {{stats.total}}
        </p>
        <div class="ui-spacer"></div>
        <p class="text-right brand-color font-weight-bold">
          Users with more than one device: {{stats.totalUsersWithMultipleDevices}}
        </p>
      </section>

      <apexchart class="pie-custom" v-if="stats.total > 0" :options="chart.options" type="pie" :series="chart.series.data"></apexchart>

      <p v-else>
        No data for Users
      </p>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import axios from 'axios';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import HelperService from '../../../services/HelperService';

  export default {
    components: {},
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        curReq: null,
        helperService: new HelperService(),
        loading: true,
        stats: [],
        chart: {
          series: {
            name: 'Users Devices',
            data: [],
          },
          options: {
            colors: [],
            labels: [],
          },
        },
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.chart.options.colors = this.helperService.getChartColors();
      this.getStats();
    },
    methods: {
      getStats() {
        this.loading = true;
        if (this.curReq) {
          this.curReq.cancel('cancelled');
        }

        this.curReq = BiStatsService.createCancelToken();

        BiStatsService.getVisitorDeviceTypes(this.filters, this.curReq.token).then(res => {
          this.stats = res.data;
          this.setUpChartData(this.stats);
          this.curReq = null; // mark the request as complete
        }).catch(err => {
          if (!axios.isCancel(err)) {
            console.log('could not get visitor users device stats', err);
            this.$toast.error('Could not get users device type stats, please refresh and try again', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setUpChartData(deviceData) {
        this.chart.series.data = [deviceData.deviceType.IOS || 0, deviceData.deviceType.Android || 0];
        this.chart.options.labels = ['IOS', 'Android'];

        // eslint-disable-next-line no-restricted-syntax
        // for (const [key, value] of Object.entries(deviceData.deviceType)) {
        //   this.chart.series.data.push(value);
        //   this.chart.options.labels.push(key);
        // }
      },
    },
  };
</script>
